import { Component } from '@angular/core';

@Component({
  selector: 'app-negotiation',
  templateUrl: './negotiation.component.html',
  styleUrl: './negotiation.component.scss'
})
export class NegotiationComponent {
  tabSelect:string='chat';
bodySpinner:boolean=false;
  emailData:any;
  constructor(){
    this.getEmaildata();
  }

  selectTab(tab:any){
   this.tabSelect=tab;
  }

  getEmaildata(){
    this.emailData = {
    "emails": [
        {
            "company_name": "Matrix",
            "contract_type": "NDA",
            "effective_date": "12/01/2026",
            "negotiation": "",
            "email":""
        },
      {
            "company_name": "Global",
            "contract_type": "MSA",
            "effective_date": "10/02/2026",
            "negotiation": "",
            "email":"",
        },
      {
            "company_name": "ABC",
            "contract_type": "DSA",
            "effective_date": "05/03/2026",
            "negotiation": "",
            "email":""
        }    ],
    "page": 1,
    "pages": 5,
    "per_page": 25,
    "total": 102
}
  }

}
